import { useEffect, type KeyboardEvent, type MutableRefObject } from "react";
import { SvgIcon } from "../../chat-list/ChatAvatar.tsx";
import { icons } from "../icons.ts";
import { startRecording } from "../recording.ts";

type ComposerTextInputProps = {
  textareaRef: MutableRefObject<HTMLTextAreaElement | null>;
  chatJid: string;
  text: string;
  onTextChange: (text: string) => void;
  onSubmit: () => void;
  onRecordingChange: (recording: boolean) => void;
  onError: (message: string) => void;
  onSuccess: (message: string) => void;
  onSent: () => void;
};

export function ComposerTextInput({
  textareaRef,
  chatJid,
  text,
  onTextChange,
  onSubmit,
  onRecordingChange,
  onError,
  onSuccess,
  onSent,
}: ComposerTextInputProps) {
  const hasText = !!text.trim();

  useEffect(() => {
    const node = textareaRef.current;
    if (!node) return;
    node.style.height = "auto";
    node.style.height = `${Math.min(140, node.scrollHeight)}px`;
  }, [textareaRef, text]);

  return (
    <>
      <div className="wa-composer-input-wrap">
        <textarea
          ref={(node) => { textareaRef.current = node; }}
          className="wa-composer-input"
          placeholder="Digite uma mensagem"
          rows={1}
          value={text}
          onChange={(event) => onTextChange(event.currentTarget.value)}
          onKeyDown={(event: KeyboardEvent<HTMLTextAreaElement>) => {
            if (event.key === "Enter" && !event.shiftKey) {
              event.preventDefault();
              onSubmit();
            }
          }}
        />
      </div>
      {hasText ? (
        <button className="wa-icon-btn wa-send" type="button" title="Enviar" aria-label="Enviar" onClick={onSubmit}>
          <SvgIcon svg={icons.send} />
        </button>
      ) : (
        <button
          className="wa-icon-btn"
          type="button"
          title="Gravar mensagem de voz"
          aria-label="Gravar mensagem de voz"
          onClick={() => void startRecording({
            onRecordingChange,
            onError,
            onSuccess,
            chatJid,
            onSent,
          })}
        >
          <SvgIcon svg={icons.mic} />
        </button>
      )}
    </>
  );
}
